// QStrap grid breakpoints

export default {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200,
}
